import request from '@/utils/request'

/**
 * 收益统计（超管全站 / 管理员授权学校 / 运营不可见）
 * ---------------------------------------------------------------------------
 * ⛔⛔ 口径：**只有用户购买爱豆的充值才算收益，其他一律不算。**
 *      所以这里拿到 summary.totalAmount 就是全部收益（= rechargeAmount）。
 *
 * ⛔ 本文件**没有广告相关的接口**。
 *    原来的 saveAdIncome / getAdIncome（录入某月广告收入）已经删除 ——
 *    收益页只讲"用户购买爱豆"，不涉及广告。
 *    广告的事去「广告分析」页（/stats/ad，仅超管）看，那边只讲行为不讲钱。
 */

/** 面板主视图 */
export function getRevenueSummary(params) {
  return request({
    url: '/admin/stats/revenue',
    method: 'get',
    params
  })
}

/** 订单明细（点开某个数字看它由哪些订单组成） */
export function getRevenueOrders(params) {
  return request({
    url: '/admin/stats/revenue/orders',
    method: 'get',
    params
  })
}

/** 重算某月（仅超管） */
export function recomputeRevenue(data) {
  return request({
    url: '/admin/stats/revenue/recompute',
    method: 'post',
    data
  })
}

/** 结账锁定（仅超管） */
export function lockRevenue(data) {
  return request({
    url: '/admin/stats/revenue/lock',
    method: 'post',
    data
  })
}

/** 解锁（仅超管，必须填原因） */
export function unlockRevenue(data) {
  return request({
    url: '/admin/stats/revenue/unlock',
    method: 'post',
    data
  })
}
